<i18n src="./content-i18n.yaml"></i18n>
<template>
    <base-card>
        <BackofficeBaseList
            :items="items"
            :headers="headers"
            :actions="actionsItems"
            :title="$t('title')"
            @reloadDataClick="reload"
            @task:unlock="onTaskUnlock"
            @task:delete="onTaskDelete"
            @task:remove-from-db="onTaskRemoveFromDB"
        >
        </BackofficeBaseList>
    </base-card>
</template>
<script>
import { mapState } from "vuex";
import taskList from "@/mixins/backoffice/taskList";
import { TaskActionTypes } from "@/data/task-action-types";
import BackofficeBaseList from "@/components/backoffice/components/base-list.vue";

export default {
    name: "BackofficeNewRepliesContent",
    mixins: [taskList],
    components: {
        BackofficeBaseList
    },
    data() {
        return {
            actionsItems: [
                TaskActionTypes.VIEW_CHECK,
                TaskActionTypes.DATA,
                TaskActionTypes.UNLOCK_TASK,
                TaskActionTypes.DELETE,
                TaskActionTypes.REMOVE_FROM_DB,
                TaskActionTypes.VIEW_HISTORY
            ]
        };
    },
    computed: {
        ...mapState("backoffice", {
            items: "newReplies"
        }),
        headers() {
            return [
                {
                    text: this.$t("header-state"),
                    align: "top",
                    sortable: false,
                    value: "state",
                    isMobile: true
                },
                {
                    text: this.$t("header-reference-id"),
                    value: "referenceId",
                    sortable: true,
                    align: "start",
                    isMobile: false
                },
                {
                    text: this.$t("header-manufacturer"),
                    value: "manufacturer",
                    sortable: true,
                    align: "start",
                    isMobile: false
                },
                {
                    text: this.$t("header-bo-employee"),
                    value: "boEmployee",
                    sortable: true,
                    align: "start",
                    isMobile: false
                },
                {
                    text: this.$t("header-bo-locked-until"),
                    value: "boLockedUntil",
                    sortable: true,
                    align: "start",
                    isMobile: false
                },
                {
                    text: this.$t("header-bo-reminder"),
                    value: "boReminder",
                    sortable: true,
                    align: "start",
                    isMobile: false
                },
                {
                    text: this.$t("header-registrant-complete-date"),
                    value: "registrantCompleteDate",
                    sortable: true,
                    align: "left",
                    isMobile: false
                },
                {
                    text: this.$t("header-operator"),
                    value: "operator",
                    sortable: true,
                    align: "left",
                    isMobile: true
                }
            ];
        }
    },
    methods: {
        fetchNewRepliesRegistrations() {
            this.loader().show();
            this.$store
                .dispatch("backoffice/fetchNewReplies")
                .then(() => {
                    this.loader().hide();
                })
                .catch(() => {
                    this.loader().hide();
                });
        },
        onTaskUnlock(task) {
            this.loader().show();
            const taskDocId = task.docId;
            this.$store
                .dispatch("backoffice/registrationUnlockForReview", taskDocId)
                .then((response) => {
                    if (response.status === 200) {
                        this.$toast.success(this.$t("msg-task-unlock-success"));
                        this.$store.commit(
                            "backoffice/removeRegistrationFromList",
                            {
                                list: "openReplies",
                                docId: task.docId
                            }
                        );
                    }
                    this.loader().hide();
                })
                .catch((error) => {
                    console.log(error);
                    this.$toast.error(this.$t("msg-task-unlock-error"));
                    this.loader().hide();
                });
        },
        onTaskRemoveFromDB(item) {
            this.loader().show();
            this.$store
                .dispatch(
                    "backoffice/deletePendingPoolRegistrationFromDB",
                    item.docId
                )
                .then((response) => {
                    if (response.status === 200) {
                        this.$toast.success(
                            this.$t("msg-task-remove-from-db-success")
                        );
                    }
                    this.loader().hide();
                })
                .catch((error) => {
                    console.log(error);
                    this.$toast.error(this.$t("msg-task-remove-from-db-error"));
                    this.loader().hide();
                });
        },
        onTaskDelete(task, result) {
            this.loader().show();
            const data = {
                docId: task.docId,
                reason: result.reason
            };
            this.$store
                .dispatch("backoffice/deletePendingPoolRegistration", data)
                .then((response) => {
                    if (response.status === 200) {
                        this.$toast.success(this.$t("msg-task-delete-success"));
                    }
                    this.loader().hide();
                })
                .catch((error) => {
                    console.log(error);
                    this.$toast.error(this.$t("msg-task-delete-error"));
                    this.loader().hide();
                });
        },
        reload() {
            return this.fetchNewRepliesRegistrations();
        }
    },
    created() {
        if (this.isAuth) {
            this.fetchNewRepliesRegistrations();
        }
    }
};
</script>
